import { Controller } from "stimulus";
import Cropper from "cropperjs";
import { useDirectUpload } from '../mixins';
import { useDispatch } from 'stimulus-use';

export default class extends Controller {
  static targets = ['button', 'image'];

  static values = {
    directUploadUrl: String,
    previewElementId: String
  };

  connect() {
    useDispatch(this);
    useDirectUpload(this);

    this.imageTarget.addEventListener('load', () => {
      this.cropper = new Cropper(this.imageTarget, {
        aspectRatio: 1,
        preview: `#${this.previewElementIdValue}`
      });
    }, false);
  }

  disconnect() {
    this.reset();
  }

  reset() {
    if (this.cropper) {
      this.cropper.destroy();
    }
  }

  setFilename(ev) {
    this.filename = ev.detail.filename;
  }

  sendCropToCloud(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    this.cropper.getCroppedCanvas().toBlob(async (blob) => {
      this.buttonTarget.classList.add('is-loading');

      const attachment = await this.upload('crop_' + this.filename, blob);

      this.buttonTarget.classList.remove('is-loading');
      this.dispatch('cropped', { attachment: attachment } );
    })
  }
}
